export const FIELD_VAL_NAMES: {
  [key: string]: { hm: boolean; hm_title?: string };
} = {
  "200_a": { hm: true, hm_title: "Naslov" },
  "200_e": { hm: false },
  "210_a": { hm: true, hm_title: "Grad" },
  "210_c": { hm: true, hm_title: "Medij" },
  "210_d": { hm: true, hm_title: "Datum" },
  "300_a": { hm: false },
  "303_a": { hm: false },
  "600_a": { hm: true, hm_title: "Ličnost" },
  "600_b": { hm: true, hm_title: "Ličnost" },
  "600_c": { hm: false },
  "600_f": { hm: false },
  "601_a": { hm: false },
  "601_b": { hm: false },
  "601_c": { hm: false },
  "601_d": { hm: false },
  "601_e": { hm: false },
  "601_f": { hm: false },
  "601_h": { hm: false },
  "602_a": { hm: false },
  "602_f": { hm: false },
  "602_w": { hm: false },
  "602_x": { hm: false },
  "602_y": { hm: false },
  "602_z": { hm: false },
  "606_a": { hm: true, hm_title: "Tema" },
  "606_w": { hm: true, hm_title: "Tema" },
  "606_x": { hm: true, hm_title: "Tema" },
  "606_y": { hm: true, hm_title: "Tema" },
  "606_z": { hm: true, hm_title: "Tema" },
  "607_a": { hm: false },
  "607_w": { hm: false },
  "607_x": { hm: false },
  "607_y": { hm: false },
  "607_z": { hm: false },
  "608_a": { hm: false },
  "608_w": { hm: false },
  "608_x": { hm: false },
  "608_y": { hm: false },
  "608_z": { hm: false },
  "609_a": { hm: false },
  "609_w": { hm: false },
  "609_x": { hm: false },
  "609_y": { hm: false },
  "609_z": { hm: false },
  "610_a": { hm: false },
  "700_a": { hm: true, hm_title: "Autor" },
  "700_b": { hm: true, hm_title: "Autor" },
  "710_a": { hm: false },
  "710_e": { hm: false },
  "710_f": { hm: false },
  "901_a": { hm: false },
  "901_b": { hm: false },
  "910_a": { hm: false },
  "992_a": { hm: false },
};
